export default "__VITE_ASSET__ChFYBsmk__"